<template>
  <v-dialog v-model="value" persistent max-width="400">

    <v-card :disabled="formLoading">
      <v-card-title>Extend Trial Period</v-card-title>

      <v-card-text class="pb-2">
        <v-row>
          <v-col>
            <v-select label="Extension reason" v-model="trialExtensionReason" :items="extensionReasons" outlined dense :hide-details="extensionReasonsErrors.length===0" :error-messages="extensionReasonsErrors" @input="$v.trialExtensionReason.$touch()" @blur="$v.trialExtensionReason.$touch()"></v-select>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col>
            <v-select label="Extension length" v-model="trialExtensionLength" :items="extensionLengths" outlined dense hide-details></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="submit">Save</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="$emit('input',false)">Cancel</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
  import { mapGetters,mapActions } from 'vuex';
  import { required } from 'vuelidate/lib/validators';

  export default {

    props: ['value'],

    validations: {
      trialExtensionReason: { required }
    },

    data() {
      return {
        formLoading: false,
        trialExtensionReason: null,
        trialExtensionLength: null,
        extensionReasons: [
          { text: 'Select an option', value: null },
          { text: 'Setup issue (provisioning failed)' },
          { text: 'Product issues (apps, etc)' },
          { text: 'Need more time to test features' },
        ],
        extensionLengths: [
          { text: '3 Days', value: 3 },
        ],
      }
    },

    computed: {
      ...mapGetters('products',['getCurrentProduct']),

      extensionReasonsErrors() {
        const errors = [];
        if (!this.$v.trialExtensionReason.$dirty) return errors;
        !this.$v.trialExtensionReason.required && errors.push('Extension reason is a required field');
        return errors;
      }
    },

    watch: {

      value(val) {
        if (val) {
          const product = this.getCurrentProduct;
          this.trialExtensionReason = product.trial_extension_reason;
          this.trialExtensionLength = product.trial_extension_length_days || this.extensionLengths[0].value;
        } else {
          this.$v.$reset();
        }
      },

    },

    methods: {

      ...mapActions('alerts', ['setAlert']),
      ...mapActions('products', ['updateProduct']),

      async submit() {
        this.$v.$touch();
        if(this.$v.$invalid){
          return;
        }

        this.formLoading = true;
        let isSuccess = await this.updateProduct({
          id: this.getCurrentProduct.id,
          data: {
            trial_extension_reason: this.trialExtensionReason,
            trial_extension_length_days: this.trialExtensionLength,
          },
          setCurrentProduct: true,
        });
        if (isSuccess) {
          this.setAlert({type: 'success',message: 'Trial extension updated successfully!'});
          this.$emit('input',false);
        }
        this.formLoading = false;
      },

    },
  }
</script>

<style lang="scss" scoped></style>
